import LineChart from '@/components/Charts/LineChart.vue';
import ButtonFixedMobile from '@/components/ButtonFixedMobile.vue';

export default {
  components: {
    LineChart,
    ButtonFixedMobile
  },

  data() {
    return {
      reportLoading: true,
      timer: null,
      isMobileFiltersShow: false,
      user: {
        login: null,
        password: null
      }
    };
  },

  computed: {
    isMobileLayout() {
      return this.$root.screen.xs || this.$root.screen.sm;
    }
  },

  async created() {
    await this.initPage();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
